import { baseClasses } from '@weatherbug/common';
import { SolarProvider } from '../providers/solarProvider';
import { ILocationSolarDateTime } from '../../components/forecasts/common/types';

const { AsyncAction } = baseClasses;
export const GET_SOLAR_DATA_BY_LAT_LNG = new AsyncAction('GET_SOLAR_DATA_BY_LAT_LNG');

interface LunarType {
    PhaseIdentifier: number;
    PhaseName: string;
    PhaseIconCode: number;
    IconURL: string;
}

export interface AlmanacResultType {
    Solar: ILocationSolarDateTime[];
    Lunar: LunarType[];
}

export type GetSolarDataType = {
    type: typeof GET_SOLAR_DATA_BY_LAT_LNG;
    payload: Promise<AlmanacResultType>;
};

export function getSolarDataByLatLng(lat: number, lng: number, count = 7): GetSolarDataType {
    return {
        type: GET_SOLAR_DATA_BY_LAT_LNG.base,
        payload: getSolarData(lat, lng, count)
    };
}

async function getSolarData(lat: number, lng: number, count: number): Promise<AlmanacResultType> {
    const op = new SolarProvider();
    return await op.getSolarDataByLatLng(lat, lng, count);
}
